export class DimensionText {

	textAnchor: 'middle' | 'end' | 'start' = 'middle';

  parathesis: boolean = false;
  drop: number = -1;
  isLabel: boolean = false;
  fontSize: string = '';
  maxWidth?: number;

  public value: string;
  public cssClass: string = '';

  constructor(
    public x: number,
    public y: number,
    public w: string | number,
    public transform: boolean,
    public helper: boolean = false,
    public tag: string = '',
    maxWidth?: number
  ) {
    if (typeof w === 'number') {
      this.value = w.toFixed(0);
    } else {
      this.value = w;
      this.cssClass = '-small';
    }
    this.maxWidth = maxWidth;
  }
}
